import { NoteHistoryOverride, noteHistoryTitleGenerator } from 'Resources/Note';
import { AccountHistoryOverride, accountHistoryTitleGenerator } from './Account';
import { expenseOverrideByType, titleGeneratorByExpenseType } from './Expense';
import { MeetingAgendaHistoryOverride, meetingAgendaHistoryTitleGenerator } from './MeetingAgenda';

export const historyOverrides = {
  account: AccountHistoryOverride,
  householdExpense: expenseOverrideByType,
  note: NoteHistoryOverride,
  meetingAgenda: MeetingAgendaHistoryOverride,
};

export const getHistoryOverrideForResource = (resource) => {
  if (resource.resourceType === 'householdExpense') {
    const expenseType = resource.attr('type');
    return historyOverrides[resource.resourceType][expenseType];
  }

  return historyOverrides[resource.resourceType];
};

export const getHistoryTitleGeneratorForResource = (resource) => {
  switch (resource.resourceType) {
    case 'householdExpense':
      return titleGeneratorByExpenseType[resource.attr('type')];
    case 'account':
      return accountHistoryTitleGenerator;
    case 'note':
      return noteHistoryTitleGenerator;
    case 'meetingAgenda':
      return meetingAgendaHistoryTitleGenerator;
    default:
      throw new Error(`No title generator for resource type ${resource.resourceType}`);
  }
};
